// List of hostings (can be domains or hostnames)
export const allowedSSOHostings = [
    "zeus-test2-andreig.78-47-73-37.nip.io",
    "zeus-test2-cristian.78-47-73-37.nip.io",
    "zeus-test2.slotmonitor.ro",
    "localhost",
    "eql-zeus-test2.slotmonitor.ro",
    "superbet.genius.slotmonitor.ro"
  ];
